import { render, staticRenderFns } from "./EmailSmsLogView.vue?vue&type=template&id=2040518e"
import script from "./EmailSmsLogView.vue?vue&type=script&lang=js"
export * from "./EmailSmsLogView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports